import {
  DATA_DEFAULT,
  STATUS_DEFAULT,
} from './constants';

export const MUTATIONS = {
  SET_STATUS: 'setStatus',
  CLEAR_PASSWORDS: 'clearPasswords',
};

export default {
  namespaced: true,
  state: {
    STATUS: { ...STATUS_DEFAULT },
    data: { ...DATA_DEFAULT },
  },
  mutations: {
    clearPasswords(state) {
      state.data.password.passwordStep1 = '';
      state.data.password.passwordStep2 = '';
    },
    setStatus(state, value) {
      const states = Object.keys(state.STATUS);
      if (states.indexOf(value) > -1) {
        states.forEach((key) => {
          state.STATUS[key] = (key === value);
        });
      }
    },
  },
  actions: {
    async setUserPassword({
      rootState,
      state,
      commit,
    }, IdpUuid) {
      commit(MUTATIONS.SET_STATUS, 'LOADING');
      const api = rootState.Setup.apiInstance;
      const data = state.data.password.passwordStep1;

      if (state.data.password.passwordStep1 !== state.data.password.passwordStep2) {
        commit(MUTATIONS.SET_STATUS, 'PASSWORD_ERROR');
      } else {
        await api.putUpdatePasswordAccount({
          data,
          IdpUuid,
        })
          .then(() => {
            commit(MUTATIONS.SET_STATUS, 'LOADED');
          })
          .catch(() => {
            commit(MUTATIONS.SET_STATUS, 'ERROR');
          });
      }
    },
    async updateUserBusinessProfilePhone({
      rootState,
      commit,
    }, {
      notificationChannelUuid,
      phone,
    }) {
      commit(MUTATIONS.SET_STATUS, 'LOADING');
      const api = rootState.Setup.apiInstance;

      try {
        await api.putUserBusinessProfilePhone({
          value: phone,
          notificationChannelUuid,
        });
        commit(MUTATIONS.SET_STATUS, 'LOADED');
      } catch (error) {
        commit(MUTATIONS.SET_STATUS, 'ERROR');
      }
    },
  },
};
